import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Agent from '../agent';

const initialState = {
  loading: false,
  profileData: {},
  errors: {},
  success: false,
  message: '',
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getProfileData = createAsyncThunk(
  'profile/get',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Profile.get(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    // get all network chain list
    [getProfileData.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [getProfileData.fulfilled]: (state, action) => {
      state.profileData = action?.payload?.user || {};
      state.loading = false;
      state.success = true;
    },

    [getProfileData.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const profileSelector = (state) => state.profile;

export const { reducer, actions } = profileSlice;
